/**
 * Translate description: Table header sort
 */

import { useContext } from 'react';
import Link from '@mui/joy/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AppContext from '../../context/AppContext';

export default function TableHeaderSort({ children, sortBy }) {
    const { sorting, setSorting } = useContext(AppContext);
    return (<Link
        underline="none"
        color="primary"
        component="button"
        onClick={() => {
            if (sorting.by !== sortBy) {
                setSorting({ by: sortBy, order: 'asc' });
            } else {
                setSorting({ by: sortBy, order: sorting?.order === 'asc' ? 'desc' : 'asc' });
            }
        }}
        fontWeight="lg"
        endDecorator={sorting?.by === sortBy ? <ArrowDropDownIcon /> : ''}
        sx={{
            '& svg': {
                transition: '0.2s',
                transform: sorting?.order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
            },
        }}
    >
        {children}
    </Link>)
}